<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        'tw-relative tw-border tw-rounded-md focus-within:tw-ring-1 tw-ring-0 tw-flex tw-items-center tw-transition-all tw-ease-in-out tw-duration-100 tw-bg-white tw-z-10 tw-mt-1',
        `focus-within:tw-ring-${focusColor} focus-within:tw-border-${focusColor} tw-border-${borderColor}`,
      ]"
    >
      <label :class="['tw-absolute tw--top-2 tw-left-2 tw--mt-px tw-inline-block tw-px-1 tw-bg-white tw-text-xs tw-font-normal', `tw-text-${labelColor}`]" v-if="label">{{
        label
      }}</label>
      <div :class="`tw-flex tw-items-center tw-text-gray-600 tw-pl-3 tw--mr-1.5 tw-font-thin sm:tw-text-${size} tw-flex-shrink-0 tw-z-0`" v-if="$slots.prefix">
        <slot name="prefix" />
      </div>
      <input
        v-bind="$attrs"
        v-on="inputListeners"
        :type="type"
        :class="[
          'form-input tw-flex-grow tw-block tw-w-full tw-border-0 tw-p-0 tw-text-gray-900 focus:tw-ring-0 tw-font-light tw-px-3 tw-py-2  tw-rounded-md ',
          `tw-placeholder-${placeholderColor} sm:tw-text-${size}`,
        ]"
        :placeholder="placeholder"
        @blur="validate"
        :value="value"
        ref="input"
        :disabled="disabled"
        :maxlength="maxLength"
      />
      <div :class="`tw-text-gray-600 tw-pr-3 tw--ml-1.5 sm:tw-text-${size}`" v-if="$slots.postfix">
        <slot name="postfix" />
      </div>
    </div>
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    value: [String, Number],
    label: String,
    placeholder: String,
    size: {
      type: String,
      default: "sm",
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
  },
  computed: {
    inputListeners: function() {
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit("input", event.target.value);
        },
      });
    },
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("input", null);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
